<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            Activity Report
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container report-container">
                <div style="width: 100%">
                    <ppl-report-filters (filterChanged)="filterChanged($event)" [filterFields]="filterFields"
                        [report]="'activityReport'"></ppl-report-filters>
                </div>
                <div class="chart-wrapper">
                    <nz-card style="width: 100%;" id="chart">
                        @if(chartOptions){
                        <nz-checkbox-group style="margin-bottom: 24px;" [(ngModel)]="selectedFilters"
                            (ngModelChange)="onFilterChange($event)">
                        </nz-checkbox-group>
                        <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart"
                            [xaxis]="chartOptions.xaxis" [stroke]="chartOptions.stroke" [colors]="chartOptions.colors"
                            [dataLabels]="chartOptions.dataLabels" [legend]="chartOptions.legend"
                            [markers]="chartOptions.markers" [grid]="chartOptions.grid" [yaxis]="chartOptions.yaxis"
                            [title]="chartOptions.title" [tooltip]="chartOptions.tooltip"></apx-chart>
                        }
                    </nz-card>
                </div>
                @if (hasVisibleColumns()) {
                <ppl-list-table [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
                    [data]="activityReportGridData" [disableSelection]="true" [cols]="visibleColumns"
                    [gridTitle]="false" [pagination]="true" [rowsToDisplay]="20" [loadPage]="true"
                    [enableActions]="false" [customDataLoaded]="true" [tableScrollable]="true">
                </ppl-list-table>
                }
            </div>
        </div>
    </div>

</ng-container>